import * as yup from "yup";

import { MAX_AD_PRODUCTS } from "../../constants";

export const adProductValidationSchema = yup.object({
  sourceId: yup
    .string()
    .trim()
    .required("Source ID (Meta ad id) is required")
    .max(200, "Source ID must be 200 characters or less"),
  productVariantIds: yup
    .array()
    .of(yup.string().required().uuid("Pick a valid product variant"))
    .min(1, "Pick at least one product")
    .max(MAX_AD_PRODUCTS, "Up to 10 products per ad")
    .required("Pick at least one product"),
  label: yup
    .string()
    .nullable()
    .max(200, "Label must be 200 characters or less"),
  isActive: yup.boolean().required()
});
